module.exports = __webpack_public_path__ + "static/img/creditCard.8ae4ef08.svg";